(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.controller.details-and-figures
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn ->details-and-figures
  [{:keys [dynamic-path dynamic-data report-data map-topo] :as props}]
  {:current-portfolio  (report-ctl/with-footnote
                        props
                        :current-portfolio-footnotes
                        (get-in report-data [:current-portfolio]))
   :exited-portfolio   (report-ctl/with-footnote
                        props
                        :exited-portfolio-footnotes
                        (get-in report-data [:exited-portfolio]))
   :investment-summary (report-ctl/with-footnote
                        props
                        :investment-summary-footnotes
                        (:investment-summary report-data))})
